import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-activity-type-act-statuses',
  templateUrl: './activity-type-act-statuses.component.html',
  styleUrls: ['./activity-type-act-statuses.component.css']
})
export class ActivityTypeActStatusesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListStatuses: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1338, {
            argtype: this.argType,
            argvalue: this.argValue
        }))[0];
    }

    private async loadStatuses() {
        if (!this.setting) return;

        return this.itemsListStatuses = await this.datatask.Post(1337, {
            argtype: this.setting.argtype,
            argvalue: this.setting.argvalue
        });
    }

    private async init() {
        await this.loadSetting();
        this.loadStatuses();
    }

    ngOnInit(): void {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    page_heading: string;
}
